import React from 'react';
import { motion } from 'framer-motion';

const AnswerOption = ({ option, isSelected, onSelect }) => {
  return (
    <motion.div 
      className={`answer-option ${isSelected ? 'selected' : ''}`}
      onClick={() => onSelect(option.id, option.text)}
      whileHover={{ scale: 1.02, backgroundColor: isSelected ? '' : '#f9fafb' }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.2 }}
    >
      <div className="flex items-center">
        <div className={`w-5 h-5 rounded-full border-2 ${isSelected ? 'border-primary-500 bg-primary-500' : 'border-gray-300'} mr-3 flex-shrink-0`}>
          {isSelected && (
            <svg className="w-full h-full text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
            </svg>
          )}
        </div>
        <span className="text-gray-800">{option.text}</span>
      </div>
    </motion.div>
  );
};

export default AnswerOption;
